export default "__VITE_ASSET__snkaon7V__"